import { render, staticRenderFns } from "./zjjl.vue?vue&type=template&id=599d9f81&scoped=true&"
import script from "./zjjl.vue?vue&type=script&lang=js&"
export * from "./zjjl.vue?vue&type=script&lang=js&"
import style0 from "./zjjl.vue?vue&type=style&index=0&id=599d9f81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d9f81",
  null
  
)

export default component.exports